import React, { useRef } from 'react';
import classnames from 'classnames';

const Image = (props) => {
    const {
        id = null,
        title,
        img,
        thumbWidth,
        thumbHeight,
        spinner = false,
        selectableImg = false,
        locationTitle = null,
        locationSlug = null,
        locationId = null,
        href = null
    } = props;

    const selectableImgBtn = useRef(null);
    
    // Debug event location images
    if (href && href.includes('/events/')) {
        console.log('Image component with event href:', {
            href,
            locationSlug,
            title
        });
    }

    return (
        <div id={id} className={classnames('position-relative', props.containerClasses || null)}>
            {/* {spinner && (
                <div className="spinner-grow text-secondary position-absolute" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            )} */}
            <a
                target="_blank"
                rel="nofollow noopener"
                href={'/ai-search?src=' + encodeURIComponent(img.src)
                    + (img.srcSig ? '&sig=' + encodeURIComponent(img.srcSig) : '')}
                className="il-search-similar-images position-absolute d-flex align-items-center ">
                <div className="icon-container bg-primary d-flex justify-content-center align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="search-icon">
                        <path fill="currentColor" d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z" />
                    </svg>
                </div>
                <p className="my-0 ml-1 font-weight-bold">Find Similar</p>
            </a>
            <button
                ref={selectableImgBtn}
                onClick={(e) => {
                    sendEvent(selectableImgBtn.current);
                }}
                data-id={img.id}
                data-src={img.src}
                data-location-title={locationTitle}
                data-location-slug={locationSlug}
                data-location-id={locationId}
                className="position-absolute il-selectable-img btn">+</button>
            {href ? (
                <a
                    target="_blank"
                    href={href}
                >
                    <Picture {...props} />
                </a>
            ) : (
                <Picture {...props} />
            )}
            {props.children}
        </div>
    );
}

const Picture = (props) => {
    const {
        img,
        title,
        imageClasses,
        onClick } = props;
    return (
        <picture>
            <source
                type="image/webp"
                // data-srcset={img.webp}
                srcSet={img.webp}
                sizes="800px"
            />
            <source
                type="image/jpeg"
                // data-srcset={img.jpeg}
                srcSet={img.jpeg}
                sizes="800px"
            />
            <img
                className={imageClasses || null}
                loading="lazy"
                width={img.width}
                height={img.height}
                src={`data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${img.width} ${img.height}'%3E%3C/svg%3E`}
                alt={title}
                // src={img.src}
                onClick={!!onClick ? onClick : null}
            />
        </picture>
    );
}

export default Image;
